import React, { useContext, useEffect, useState } from 'react';

import Legend from './Legend';
import { LocaleContext } from 'Components/hooks/context';
import USStateCartogram from '@reuters-graphics/chart-module-us-covid-cartogram';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import debounce from 'lodash/debounce';
import fetchJson from 'Utils/fetchJson';

const chart = new USStateCartogram();

const UnitedStates = (props) => {
  const { content } = props;
  const [data, setData] = useState(null);
  const [parameter, setParameter] = useState('cases');
  const [uniformScale, setUniformScale] = useState(false);

  const locale = useContext(LocaleContext);

  const chartContainer = React.createRef();

  const resize = debounce(() => {
    chart.draw();
  }, 250);

  useEffect(() => {
    const fetchData = async() => {
      const data = await fetchJson('https://graphics.thomsonreuters.com/data/2020/covid-us-states/data.json');
      setData(data);
    };
    fetchData();
  }, []);

  // Draw chart
  useEffect(() => {
    if (!data) return;

    chart
      .selection(chartContainer.current)
      .props({
        locale,
        parameter,
        uniformScale,
        stroke: 'rgba(255, 255, 255, 0.25)',
        strokeWidth: 2,
      })
      .data([data])
      .draw();
  }, [chartContainer, data, parameter, locale, uniformScale]);

  // Resize chart
  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <>
      <section>
        <h4>{content.title}</h4>
      </section>
      <section className={classnames(component, 'wide')}>
        <section className='options-container clearfix'>
          <div className='options'>
            <button
              className={parameter === 'cases' ? 'active' : ''}
              onClick={() => setParameter('cases')}
            >{content.cases}
            </button>
            <button
              className={parameter === 'deaths' ? 'active' : ''}
              onClick={() => setParameter('deaths')}
            >{content.deaths}
            </button>
          </div>
          <div className='options'>
            <button
              className={uniformScale ? '' : 'active'}
              onClick={() => setUniformScale(false)}
            >{content.adjusted}
            </button>
            <button
              className={uniformScale ? 'active' : ''}
              onClick={() => setUniformScale(true)}
            >{content.uniform}
            </button>

          </div>
        </section>
        <Legend content={content} />
        <div className='us-states-cartogram' ref={chartContainer} />
      </section>
    </>
  );
};

export default UnitedStates;
